import React from 'react';
import { number, func } from 'prop-types';
import { useSelector } from 'react-redux';
import { wrapTextForSVG } from 'utils/utils';


Title.propTypes = {
  floorLevel: number,
  rotate: number,
  onTitleClick: func,
};

function DraggableTitleGroup({ shopTitle, position, cx, cy, titleRotate, rotate, id, svgId, floorLevel, onTitleClick }) {
  const baseX = position?.x ?? cx;
  const baseY = position?.y ?? cy;



  const lines = wrapTextForSVG(shopTitle);
  const handleClick = (e) => {
    // Only trigger click if not dragging
    if (onTitleClick) {
      onTitleClick({ title: shopTitle, id, position, cx, cy, floorLevel });
    }
  };

  return (
    <g onClick={handleClick}>
      <text
        x={baseX}
        y={baseY}
        fontSize={floorLevel === 1 ? "5" : "6"}
        fill="black"
        fontWeight={500}
        textAnchor="middle"
        dominantBaseline="middle"
        transform={`rotate(${titleRotate || rotate}, ${baseX}, ${baseY})`}
        style={{ userSelect: 'none' }}
      >
        {lines.map((line, lineIndex) => (
          <tspan
            key={lineIndex}
            x={baseX}
            dy={lineIndex === 0 ? 0 : '1.0em'}
            textAnchor="middle"
          >
            {line}
          </tspan>
        ))}
      </text>
    </g>
  );
}

function Title({ floorLevel, rotate, onTitleClick }) {
  const targetProperty = floorLevel + 'F';
  const titleState = useSelector((state) => state.titleCoors);
  const title = titleState[targetProperty] || [];

  return (
    <>
      {title.map(({ title: shopTitle, position, cx, cy, rotate: titleRotate, id, svgId }, index) => (
        <DraggableTitleGroup
          key={index}
          shopTitle={shopTitle}
          position={position}
          cx={cx}
          cy={cy}
          titleRotate={titleRotate}
          rotate={rotate}
          id={id}
          svgId={svgId}
          floorLevel={floorLevel}
          onTitleClick={onTitleClick}
        />
      ))}
    </>
  );
}

export default Title;
